import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ApiError, api } from "../lib/api";
import * as repo from "../lib/repo";
import { workLocationLinks, type WorkSite } from "../lib/workLocation";
import { Card } from "./ui";

export function JobLocation({jobId,siteId}:{jobId:string;siteId:string}) {
  const location=useQuery({queryKey:["job-location",jobId,siteId], networkMode:"always", retry:false,
    queryFn:()=>loadJobLocation(jobId,siteId)
    });
  const site=location.error ? undefined : location.data;
  const links=site ? workLocationLinks(site) : null;
  return <Card title="Work location">
    {location.isPending && <p>Loading work location...</p>}
    {location.error && <><p role="alert">{location.error.message}</p><button className="btn" onClick={()=>void location.refetch()}>Retry location</button></>}
    {site && links && <>
      <b>{site.name}</b><p>{links.address || "No street address recorded."}</p>
      {site.cached && <p className="notice notice-warn">Saved device copy. Reconnect and refresh to check the latest address and access notes.</p>}
      <div className="btn-row">
        {links.map && <a className="btn" href={links.map} target="_blank" rel="noreferrer">{links.hasPin ? "View confirmed map pin" : "Find address on OpenStreetMap"}</a>}
        {links.directions && <a className="btn" href={links.directions} target="_blank" rel="noreferrer">Driving directions (Google Maps)</a>}
        <Link className="btn" to={`/sites/${site.id}`}>Site details</Link>
        <button className="btn" type="button" disabled={location.isFetching} onClick={()=>void location.refetch()}>Refresh location</button>
      </div>
      <p className="tiny muted">Map links share the destination only when opened. Your maps app chooses the starting point; Keystone does not track your location.</p>
      {(site.induction_required || site.swms_required) && <p className="notice notice-warn">Before starting: {[site.induction_required ? "site induction required" : null,site.swms_required ? "SWMS required" : null].filter(Boolean).join("; ")}.</p>}
      <h3>Access notes</h3><p style={{whiteSpace:"pre-wrap"}}>{site.access_notes || "No access notes recorded."}</p>
    </>}
  </Card>;
}

export async function loadJobLocation(jobId:string,siteId:string):Promise<WorkSite> {
      try {return await api.jobs.location(jobId);}
      catch(error) {
        // A refusal must not reveal an older saved copy.
        if(error instanceof ApiError && error.status>0) throw error;
        const saved=await repo.site(siteId);
        if(!saved) throw error;
        return {...saved,lat:null,lng:null,cached:true};
      }
}
